module.exports = __webpack_public_path__ + "media/banker_win.e7a527a4.mp3";